<template>
  <div class="channel">
    <c-table
      ref="table"
      :fields="fields"
      :columns="columns"
      url="/changjing/hot"
      :key="key"
      @before-fetch="beforeFetch"
      @after-fetch="afterFetch"
    >
      <el-table-column slot="channel" label="渠道栏目" show-overflow-tooltip width="160">
        <template v-slot="{row}">
          <span>{{row | convertChannel}}</span>
        </template>
      </el-table-column>
      <el-table-column slot="caozuo" label="操作" :width="previllage === 2 || previllage === 10 ? 180 : 60" fixed="right">
        <template v-slot="{row}">
          <el-button type="text" @click="detail(row.id)">详情</el-button>
          <el-button
            v-if="permissionFn('write')"
            type="text"
            @click="goToEdit(row)"
          >编辑</el-button>
          <el-button
           v-if="permissionFn('admin')"
            type="text"
            @click="remove(row, $event)"
          >删除</el-button>
        </template>
      </el-table-column>
    </c-table>
  </div>
</template>

<script>
import CTable from '@/components/common/table'
import permissionMixins from '@/mixins/permission'
export default {
  components: { CTable },
  mixins: [permissionMixins],
  data() {
    return {
      loading: false,
      fields: [
        {
          prop: 'name',
          placeholder: '关键词',
          clearable: true
        },
        {
          prop: 'channel',
          placeholder: '栏目',
          component: 'cascader',
          options: this.$store.state.global.channels,
          clearable: true,
          filterable: true,
          'checkStrictly': true,
          props: { checkStrictly: true },
          value: []
        },
        {
          prop: 'status',
          placeholder: '状态',
          component: 'select',
          options: ['合作中', '测试中', '暂停中', '淘汰退出', '待测试'].map(x => {
            return {
              value: x,
              label: x
            }
          }),
          clearable: true,
          filterable: true,
          value: ''
        }
      ],
      columns: [
        { prop: 'name', label: '渠道名', width: 200 },
        { slot: 'channel', label: '渠道栏目' },
        { prop: 'view', label: '浏览次数' },
        { prop: 'download', label: '下载次数' },
        { prop: 'remark', label: '留言互动数' },
        { slot: 'caozuo' }
      ],
      key: Date.now(),
      previllage: 1
    }
  },
  // watch: {
  //   previllage(newOne) {
  //     console.log('debug: previllage', newOne)
  //   }
  // },

  methods: {
    beforeFetch(params) {
      [params.first, params.second] = params.channel
      delete params.channel
    },
    afterFetch(res) {
      this.previllage = res.data.previllage
    },
    detail(id) {
      window.open(`/changjing/detail/${id}`)
    },
    remove (row, event) {
      this.$_confirm({
        operateText: event.target.innerText,
        name: row.name,
        operate: () =>
          this.$http.post(`/changjing/jdelete`, {
            id: row.id
          }),
        callback: () => {
          this.$refs.table.reload()
        }
      })
    },
    // 去编辑页面，需要新窗口打开
    goToEdit(row) {
      window.open(`/changjing/edit/${row.id}`)
    }
  }
}
</script>

<style lang="scss">
</style>
